/**
 * WOM Review Flicker — Swiper carousel with WOM API data
 */
(function () {
  var STAR_PATH =
    'M9.20283 27L16.001 21.807L22.7972 27L20.2018 18.596L27 13.403H18.5984L16.001 5L13.4037 13.403H5L11.7982 18.596L9.20283 27Z';

  var VERIFIED_SVG =
    '<svg fill="none" height="512" viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="m21.5609 10.7386-1.36-1.58001c-.26-.3-.47-.86-.47-1.26v-1.7c0-1.06-.87-1.93-1.93-1.93h-1.7c-.39 0-.96-.21-1.26-.47l-1.58-1.36c-.69-.59-1.82-.59-2.52 0l-1.57004 1.37c-.3.25-.87.46-1.26.46h-1.73c-1.06 0-1.93.87-1.93 1.93v1.71c0 .39-.21.95-.46 1.25l-1.35 1.59001c-.58.69-.58 1.81 0 2.5l1.35 1.59c.25.3.46.86.46 1.25v1.71c0 1.06.87 1.93 1.93 1.93h1.73c.39 0 .96.21 1.26.47l1.58004 1.36c.69.59 1.82.59 2.52 0l1.58-1.36c.3-.26.86-.47 1.26-.47h1.7c1.06 0 1.93-.87 1.93-1.93v-1.7c0-.39.21-.96.47-1.26l1.36-1.58c.58-.69.58-1.83-.01-2.52zm-5.4-.63-4.83 4.83c-.14.14-.33.22-.53.22s-.39-.08-.53-.22l-2.42004-2.42c-.29-.29-.29-.77 0-1.06s.77-.29 1.06 0l1.89004 1.89 4.3-4.30001c.29-.29.77-.29 1.06 0s.29.77 0 1.06001z" fill="#000000"/></svg>';

  var READ_MORE_MIN_CHARS = 140;

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildStarSvg(options) {
    var size = options.size || 32;
    var fill = options.fill || '#00b67a';
    var uid = options.uid || '0';
    var rectFill = fill;

    if (options.partialPercent) {
      var pct = options.partialPercent;
      rectFill = 'url(#wrf-grad-' + uid + ')';
      var defs =
        '<defs><linearGradient id="wrf-grad-' +
        uid +
        '"><stop offset="0%" stop-color="' +
        fill +
        '"/><stop offset="' +
        pct +
        '%" stop-color="' +
        fill +
        '"/><stop offset="' +
        pct +
        '%" stop-color="#dddddd"/><stop offset="100%" stop-color="#dddddd"/></linearGradient>' +
        '<clipPath id="wrf-clip-' +
        uid +
        '"><rect width="22" height="22" fill="#ffffff" transform="translate(5 5)"/></clipPath></defs>';

      return (
        '<svg width="' +
        size +
        '" height="' +
        size +
        '" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
        defs +
        '<rect width="32" height="32" fill="' +
        rectFill +
        '"/>' +
        '<g clip-path="url(#wrf-clip-' +
        uid +
        ')"><path d="' +
        STAR_PATH +
        '" fill="#ffffff"/></g></svg>'
      );
    }

    var defs =
      '<defs><clipPath id="wrf-clip-' +
      uid +
      '"><rect width="22" height="22" fill="#ffffff" transform="translate(5 5)"/></clipPath></defs>';

    return (
      '<svg width="' +
      size +
      '" height="' +
      size +
      '" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      defs +
      '<rect width="32" height="32" fill="' +
      rectFill +
      '"/>' +
      '<g clip-path="url(#wrf-clip-' +
      uid +
      ')"><path d="' +
      STAR_PATH +
      '" fill="#ffffff"/></g></svg>'
    );
  }

  function buildSummaryStars(rating, uid) {
    var value = Math.max(0, Math.min(5, parseFloat(rating) || 0));
    var full = Math.floor(value);
    var decimal = value - full;
    var html = '';
    var i;

    for (i = 0; i < 5; i++) {
      if (i < full) {
        html += buildStarSvg({ size: 32, fill: '#00b67a', uid: uid + '-s' + i });
      } else if (i === full && decimal > 0) {
        html += buildStarSvg({
          size: 32,
          fill: '#00b67a',
          partialPercent: Math.round(decimal * 100),
          uid: uid + '-s' + i
        });
      } else {
        html += buildStarSvg({ size: 32, fill: '#dddddd', uid: uid + '-s' + i });
      }
    }

    return html;
  }

  function buildCardStars(rating, uid) {
    var count = Math.max(0, Math.min(5, Math.round(parseFloat(rating) || 5)));
    var html = '';
    var i;
    for (i = 0; i < 5; i++) {
      html += buildStarSvg({
        size: 32,
        fill: i < count ? '#06895e' : '#dddddd',
        uid: uid + '-c' + i
      });
    }
    return html;
  }

  function getReviewImageUrls(review) {
    var images = review.images || review.review_images || [];
    var urls = [];
    var i;

    if (!Array.isArray(images)) return urls;

    for (i = 0; i < images.length; i++) {
      var img = images[i];
      var url = typeof img === 'string' ? img : img.s3_url || img.url || img.src || '';
      if (url) urls.push(url);
    }

    return urls;
  }

  function reviewHasImages(review) {
    return getReviewImageUrls(review).length > 0;
  }

  function buildMediaHtml(urls, position, uid, cardLayout) {
    if (!urls.length || position === 'hidden') return '';

    var isSplit = cardLayout === 'split';
    var isVertical = cardLayout === 'vertical';
    var maxVisible = isSplit || isVertical ? 1 : 3;
    var visible = urls.slice(0, maxVisible);
    var extra = urls.length - maxVisible;
    var multiClass = !isSplit && !isVertical && visible.length > 1 ? ' wrf-slide__media--multi' : '';
    var layoutClass = isSplit ? ' wrf-slide__media--split' : isVertical ? ' wrf-slide__media--vertical' : '';
    var html =
      '<div class="wrf-slide__media wrf-slide__media--' +
      position +
      multiClass +
      layoutClass +
      '">';
    var i;

    for (i = 0; i < visible.length; i++) {
      var isClickable = isSplit || isVertical;
      var tag = isClickable ? 'button' : 'div';
      var tagClose = isClickable ? 'button' : 'div';
      html +=
        '<' +
        tag +
        (isClickable ? ' type="button"' : '') +
        ' class="wrf-slide__media-item' +
        (isClickable ? ' wrf-slide__media-item--clickable swiper-no-swiping' : '') +
        '"' +
        (isClickable
          ? ' data-wrf-review-image data-wrf-image-index="' +
            i +
            '" aria-label="Open review photo"'
          : '') +
        '>' +
        '<img src="' +
        escapeHtml(visible[i]) +
        '" alt="Customer review photo" loading="lazy" draggable="false">' +
        (i === visible.length - 1 && extra > 0
          ? '<span class="wrf-slide__media-more">+' + extra + '</span>'
          : '') +
        '</' +
        tagClose +
        '>';
    }

    html += '</div>';
    return html;
  }

  function buildTextHtml(text, options) {
    var opts = options || {};
    var trimmed = String(text || '').trim();
    var minChars = opts.minCharsForReadMore || READ_MORE_MIN_CHARS;
    var needsMore = opts.alwaysOfferReadMore === true || trimmed.length > minChars;
    var opensModal = opts.readMoreOpensModal === true;

    return (
      '<div class="wrf-slide__text' +
      (needsMore ? ' wrf-slide__text--clamped' : '') +
      (opensModal ? ' wrf-slide__text--modal' : '') +
      '" data-wrf-text>' +
      '<p data-wrf-text-body>' +
      escapeHtml(trimmed) +
      '</p>' +
      (needsMore
        ? '<button type="button" class="wrf-slide__read-more" data-wrf-read-more' +
          (opensModal ? ' data-wrf-read-more-mode="modal"' : '') +
          ' aria-expanded="false">Read more</button>'
        : '') +
      '</div>'
    );
  }

  function ensureVerticalReadMoreButton(textWrap) {
    if (!textWrap) return;

    var body = textWrap.querySelector('[data-wrf-text-body]');
    if (!body) return;

    textWrap.classList.add('wrf-slide__text--clamped');

    var clipped = body.scrollHeight > body.clientHeight + 1;
    var btn = textWrap.querySelector('[data-wrf-read-more]');

    if (clipped) {
      if (!btn) {
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'wrf-slide__read-more';
        btn.setAttribute('data-wrf-read-more', '');
        btn.setAttribute('data-wrf-auto-read-more', 'true');
        btn.setAttribute('aria-expanded', 'false');
        btn.textContent = 'Read more';
        textWrap.appendChild(btn);
      }
      btn.setAttribute('data-wrf-read-more-mode', 'modal');
    } else if (btn && btn.getAttribute('data-wrf-auto-read-more') === 'true') {
      btn.remove();
      textWrap.classList.remove('wrf-slide__text--clamped');
    }
  }

  function normalizeReviewForModal(review) {
    return {
      author: review.user_name || review.name || review.author || 'Customer',
      content:
        review.review_text || review.text || review.body || review.content || '',
      title: review.title || '',
      rating: review.rating || 5,
      verified: !!(review.verified_batch || review.verified),
      createdAt: review.date || review.created_at || review.createdAt || '',
      location: review.location || ''
    };
  }

  function buildModalImageList(review) {
    var normalized = normalizeReviewForModal(review);
    return getReviewImageUrls(review).map(function (url) {
      return { url: url, review: normalized };
    });
  }

  function openWrfReviewModalFallback(review, imageUrls, startIndex, flickerInstance) {
    var existingOverlay = document.querySelector('.wrf-review-modal-overlay');
    if (existingOverlay && existingOverlay.parentNode) {
      var previousFlicker = existingOverlay.__wrfFlickerInstance;
      if (previousFlicker && typeof previousFlicker.resumeAutoplayAfterModal === 'function') {
        previousFlicker.resumeAutoplayAfterModal();
      }
      existingOverlay.parentNode.removeChild(existingOverlay);
      document.body.style.overflow = '';
    }

    var normalized = normalizeReviewForModal(review);
    var urls = imageUrls && imageUrls.length ? imageUrls : getReviewImageUrls(review);
    var isMobile = window.innerWidth < 768;
    var activeIndex = Math.max(0, Math.min(startIndex || 0, Math.max(urls.length - 1, 0)));
    var overlay = document.createElement('div');
    var panel = document.createElement('div');
    var body = document.createElement('div');
    var mediaCol = document.createElement('div');
    var mediaWrap = document.createElement('div');
    var img = document.createElement('img');
    var detailCol = document.createElement('div');
    var closeBtn = document.createElement('button');

    function closeModal(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      document.removeEventListener('keydown', onEscape);
      if (overlay.parentNode) {
        overlay.parentNode.removeChild(overlay);
      }
      document.body.style.overflow = '';
      if (flickerInstance && typeof flickerInstance.resumeAutoplayAfterModal === 'function') {
        flickerInstance.resumeAutoplayAfterModal();
      }
    }

    function onEscape(event) {
      if (event.key === 'Escape') closeModal(event);
    }

    overlay.className = 'wrf-review-modal-overlay';
    overlay.__wrfFlickerInstance = flickerInstance || null;
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Customer review');

    panel.className = 'wrf-review-modal';

    closeBtn.type = 'button';
    closeBtn.className = 'wrf-review-modal__close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML = '&times;';
    closeBtn.addEventListener('click', closeModal);

    body.className = 'wrf-review-modal__body';
    mediaCol.className = 'wrf-review-modal__media-col';
    mediaWrap.className = 'wrf-review-modal__media-wrap';
    img.className = 'wrf-review-modal__image';
    img.alt = 'Customer review photo';
    detailCol.className = 'wrf-review-modal__detail-col';

    function render() {
      if (urls.length) {
        img.src = urls[activeIndex];
        img.hidden = false;
      } else {
        img.hidden = true;
      }

      detailCol.innerHTML =
        (normalized.title
          ? '<p class="wrf-review-modal__title">' + escapeHtml(normalized.title) + '</p>'
          : '') +
        '<p class="wrf-review-modal__name">' +
        escapeHtml(normalized.author) +
        (normalized.verified ? ' <span class="wrf-review-modal__verified">Verified</span>' : '') +
        '</p>' +
        '<div class="wrf-review-modal__stars" aria-hidden="true">' +
        buildCardStars(normalized.rating, 'modal-fallback') +
        '</div>' +
        '<div class="wrf-review-modal__content">' +
        escapeHtml(normalized.content) +
        '</div>';
    }

    mediaWrap.appendChild(img);
    mediaCol.appendChild(mediaWrap);
    body.appendChild(mediaCol);
    body.appendChild(detailCol);
    panel.appendChild(closeBtn);
    panel.appendChild(body);
    overlay.appendChild(panel);
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) closeModal(event);
    });
    document.addEventListener('keydown', onEscape);

    render();
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';

    if (isMobile) {
      panel.classList.add('wrf-review-modal--mobile');
    }
  }

  function openReviewModal(review, imageIndex, flickerInstance) {
    var images = buildModalImageList(review);
    if (!images.length && !normalizeReviewForModal(review).content) return;

    var startIndex = Math.max(0, Math.min(imageIndex || 0, images.length - 1));

    openWrfReviewModalFallback(
      review,
      images.map(function (item) {
        return item.url;
      }),
      startIndex,
      flickerInstance
    );
  }

  function getFlickerInstanceFromNode(node) {
    var section = node && node.closest('[data-wom-review-flicker]');
    return section && section.__wrfInstance ? section.__wrfInstance : null;
  }

  function handleFlickerDocumentClick(event) {
    var imageTrigger = event.target.closest('[data-wrf-review-image]');
    if (imageTrigger) {
      var flicker = getFlickerInstanceFromNode(imageTrigger);
      if (!flicker || !flicker.track || !flicker.track.contains(imageTrigger)) return;

      event.preventDefault();
      event.stopPropagation();

      var card = imageTrigger.closest('[data-flicker-card]');
      var review = flicker.getReviewFromCard(card);
      var imageIndex = parseInt(imageTrigger.getAttribute('data-wrf-image-index'), 10) || 0;

      if (flicker.swiper && flicker.swiper.autoplay && typeof flicker.swiper.autoplay.stop === 'function') {
        flicker.pauseAutoplayForModal();
      }

      if (review) {
        openReviewModal(review, imageIndex, flicker);
      }
      return;
    }

    var readMoreBtn = event.target.closest('[data-wrf-read-more][data-wrf-read-more-mode="modal"]');
    if (!readMoreBtn) return;

    var readMoreFlicker = getFlickerInstanceFromNode(readMoreBtn);
    if (!readMoreFlicker || !readMoreFlicker.track || !readMoreFlicker.track.contains(readMoreBtn)) return;

    event.preventDefault();
    event.stopPropagation();

    if (readMoreFlicker.swiper && readMoreFlicker.swiper.autoplay) {
      readMoreFlicker.pauseAutoplayForModal();
    }

    var readMoreCard = readMoreBtn.closest('[data-flicker-card]');
    var readMoreReview = readMoreFlicker.getReviewFromCard(readMoreCard);
    if (readMoreReview) {
      openReviewModal(readMoreReview, 0, readMoreFlicker);
    }
  }

  function buildSlideHtml(review, index, options) {
    var name = review.user_name || review.name || 'Customer';
    var title = review.title || 'Great product';
    var text = review.review_text || review.text || review.body || '';
    var rating = review.rating || 5;
    var imageUrls = getReviewImageUrls(review);
    var imagePosition = options.imagePosition || 'above';
    var cardLayout = options.cardLayout || 'vertical';
    var showVerified = options.showVerified;
    var sectionId = options.sectionId;
    var hasMedia = imageUrls.length > 0 && imagePosition !== 'hidden';
    var splitMode = cardLayout === 'split' && hasMedia;
    var verticalMode = cardLayout === 'vertical' && hasMedia;
    var mediaHtml = buildMediaHtml(imageUrls, imagePosition, sectionId + '-' + index, cardLayout);

    var verifiedHtml = showVerified
      ? '<p class="wrf-slide__verified">Verified customer ' + VERIFIED_SVG + '</p>'
      : '';

    var starsHtml =
      '<div class="wrf-slide__stars" aria-label="' +
      escapeHtml(rating) +
      ' out of 5 stars">' +
      buildCardStars(rating, sectionId + '-' + index) +
      '</div>';

    var isVerticalSection = cardLayout === 'vertical';
    var titleHtml = '<p class="wrf-slide__title">' + escapeHtml(title) + '</p>';
    var textHtml = buildTextHtml(text, {
      readMoreOpensModal: splitMode || isVerticalSection,
      minCharsForReadMore: isVerticalSection ? 72 : READ_MORE_MIN_CHARS
    });
    var authorHtml =
      '<div class="wrf-slide__bottom">' +
      '<div class="wrf-slide__author">' +
      '<p class="wrf-slide__name">' +
      escapeHtml(name) +
      '</p>' +
      verifiedHtml +
      '</div>' +
      '</div>';

    var authorUnderMediaHtml =
      '<div class="wrf-slide__author wrf-slide__author--under-media">' +
      '<p class="wrf-slide__name">' +
      escapeHtml(name) +
      '</p>' +
      verifiedHtml +
      '</div>';

    if (splitMode) {
      return (
        '<div class="wrf-slide swiper-slide wrf-slide--has-media wrf-slide--split" data-flicker-card data-wrf-review-index="' +
        index +
        '">' +
        starsHtml +
        '<div class="wrf-slide__split">' +
        '<div class="wrf-slide__split-col wrf-slide__split-col--media">' +
        mediaHtml +
        authorUnderMediaHtml +
        '</div>' +
        '<div class="wrf-slide__split-col wrf-slide__split-col--content">' +
        titleHtml +
        textHtml +
        '</div>' +
        '</div>' +
        '</div>'
      );
    }

    if (verticalMode) {
      return (
        '<div class="wrf-slide swiper-slide wrf-slide--has-media wrf-slide--vertical" data-flicker-card data-wrf-review-index="' +
        index +
        '">' +
        starsHtml +
        '<div class="wrf-slide__vertical">' +
        '<div class="wrf-slide__vertical-media">' +
        mediaHtml +
        '</div>' +
        '<div class="wrf-slide__vertical-content">' +
        titleHtml +
        textHtml +
        authorHtml +
        '</div>' +
        '</div>' +
        '</div>'
      );
    }

    var bodyHtml = titleHtml;
    if (imagePosition === 'above') {
      bodyHtml += mediaHtml + textHtml;
    } else if (imagePosition === 'below') {
      bodyHtml += textHtml + mediaHtml;
    } else {
      bodyHtml += textHtml;
    }

    return (
      '<div class="wrf-slide swiper-slide' +
      (imageUrls.length ? ' wrf-slide--has-media' : '') +
      '" data-flicker-card' +
      (isVerticalSection ? ' data-wrf-review-index="' + index + '"' : '') +
      '>' +
      starsHtml +
      bodyHtml +
      authorHtml +
      '</div>'
    );
  }

  function prepareReviews(reviews, options) {
    var list = reviews.filter(function (r) {
      return (r.review_text || r.text || r.body || '').trim().length > 0;
    });

    if (options.onlyWithImages) {
      list = list.filter(reviewHasImages);
    } else if (options.prioritizeImages) {
      var withImages = [];
      var withoutImages = [];
      list.forEach(function (r) {
        if (reviewHasImages(r)) withImages.push(r);
        else withoutImages.push(r);
      });
      list = withImages.concat(withoutImages);
    }

    return list.slice(0, options.maxReviews);
  }

  function getApiUrl() {
    var cfg = window.vesselsWOMConfig || window.clientWOMConfig || {};
    var reviewsUrlFn = cfg.reviewsApiUrl || cfg.getReviewsApiUrl;

    if (typeof reviewsUrlFn === 'function') {
      var override = reviewsUrlFn();
      if (override) {
        return String(override).split('?')[0] + '?offset=0&limit=100';
      }
    } else if (reviewsUrlFn && typeof reviewsUrlFn === 'string') {
      return String(reviewsUrlFn).split('?')[0] + '?offset=0&limit=100';
    }

    var companyId = cfg.companyId || 'flicker';
    var slug =
      (typeof cfg.getProductHandle === 'function' && cfg.getProductHandle()) ||
      cfg.fixedProductSlug ||
      cfg.defaultProductSlug ||
      'the-home-posts';
    return 'https://api.thewordofmouth.in/api/reviews/' + companyId + '/' + slug + '?offset=0&limit=100';
  }

  async function fetchReviews() {
    if (window.reviewsAPIManager && typeof window.reviewsAPIManager.fetchReviews === 'function') {
      return window.reviewsAPIManager.fetchReviews();
    }

    var response = await fetch(getApiUrl(), {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'omit',
      mode: 'cors'
    });

    if (!response.ok) throw new Error('Failed to load reviews');
    return response.json();
  }

  function waitForSwiper(callback, attempts) {
    if (window.Swiper) {
      callback();
      return;
    }
    if ((attempts || 0) > 40) return;
    setTimeout(function () {
      waitForSwiper(callback, (attempts || 0) + 1);
    }, 100);
  }

  function ReviewFlicker(root) {
    if (root.__wrfInstance) return root.__wrfInstance;

    this.root = root;
    this.sectionId = root.getAttribute('data-section-id') || 'wrf';
    this.track = root.querySelector('[data-flicker-track]');
    this.sliderEl = root.querySelector('[data-flicker-slider]');
    this.prevBtn = root.querySelector('[data-flicker-prev]');
    this.nextBtn = root.querySelector('[data-flicker-next]');
    this.summary = root.querySelector('[data-flicker-summary]');
    this.scoreEl = root.querySelector('[data-flicker-score]');
    this.summaryStars = root.querySelector('[data-flicker-summary-stars]');
    this.maxReviews = parseInt(root.getAttribute('data-max-reviews'), 10) || 20;
    this.showVerified = root.getAttribute('data-show-verified') !== 'false';
    this.imagePosition = root.getAttribute('data-image-position') || 'above';
    this.onlyWithImages = root.getAttribute('data-only-with-images') === 'true';
    this.prioritizeImages = root.getAttribute('data-prioritize-images') !== 'false';
    this.cardLayout = root.getAttribute('data-card-layout') || 'stacked';
    this.swiper = null;

    root.__wrfInstance = this;
    this.init();
  }

  ReviewFlicker.prototype.init = async function () {
    try {
      var data = await fetchReviews();
      var reviews = prepareReviews((data && data.reviews) || [], {
        maxReviews: this.maxReviews,
        onlyWithImages: this.onlyWithImages,
        prioritizeImages: this.prioritizeImages,
        imagePosition: this.imagePosition
      });

      if (!reviews.length) {
        this.showEmpty();
        return;
      }

      this.reviews = reviews;
      this.renderSummary(data, reviews);
      this.renderSlides(reviews);
      this.initSwiper();
    } catch (err) {
      this.showEmpty('Unable to load reviews right now.');
    }
  };

  ReviewFlicker.prototype.renderSummary = function (data, reviews) {
    var rating = parseFloat(data.overall_rating || data.overallRating || 0);
    if (!rating && reviews.length) {
      var sum = 0;
      reviews.forEach(function (r) {
        sum += parseFloat(r.rating) || 0;
      });
      rating = sum / reviews.length;
    }

    if (!rating) {
      this.summary.hidden = true;
      return;
    }

    this.scoreEl.innerHTML = '<p>' + rating.toFixed(1) + '/5</p>';
    this.summaryStars.innerHTML = buildSummaryStars(rating, this.sectionId);
    this.summary.hidden = false;
  };

  ReviewFlicker.prototype.renderSlides = function (reviews) {
    var html = '';
    var i;
    var options = {
      showVerified: this.showVerified,
      sectionId: this.sectionId,
      imagePosition: this.imagePosition,
      cardLayout: this.cardLayout
    };

    for (i = 0; i < reviews.length; i++) {
      html += buildSlideHtml(reviews[i], i, options);
    }
    this.track.innerHTML = html;
    var self = this;
    window.requestAnimationFrame(function () {
      self.syncVerticalSectionReadMore();
    });
    this.bindSlideInteractions();
  };

  ReviewFlicker.prototype.syncVerticalSectionReadMore = function () {
    if (this.cardLayout !== 'vertical') return;

    this.track.querySelectorAll('[data-wrf-text]').forEach(function (textWrap) {
      ensureVerticalReadMoreButton(textWrap);
    });
  };

  ReviewFlicker.prototype.getReviewFromCard = function (card) {
    if (!card) return null;
    var reviewIndex = parseInt(card.getAttribute('data-wrf-review-index'), 10);
    if (reviewIndex < 0 || !this.reviews || !this.reviews[reviewIndex]) return null;
    return this.reviews[reviewIndex];
  };

  ReviewFlicker.prototype.bindSlideInteractions = function () {
    var self = this;

    if (this._slideInteractionHandler) {
      this.track.removeEventListener('click', this._slideInteractionHandler);
    }

    this._slideInteractionHandler = function (event) {
      var btn = event.target.closest('[data-wrf-read-more]');
      if (!btn || !self.track.contains(btn)) return;
      if (btn.getAttribute('data-wrf-read-more-mode') === 'modal') return;

      event.preventDefault();
      event.stopPropagation();

      var textWrap = btn.closest('[data-wrf-text]');
      if (!textWrap) return;

      var expanded = textWrap.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      btn.textContent = expanded ? 'Read less' : 'Read more';
    };

    this.track.addEventListener('click', this._slideInteractionHandler);
  };

  ReviewFlicker.prototype.bindReadMoreHandlers = function () {
    this.bindSlideInteractions();
  };

  function resetSwiperToStart(swiper) {
    if (!swiper) return;

    if (swiper.params.loop && typeof swiper.slideToLoop === 'function') {
      swiper.slideToLoop(0, 0);
      return;
    }

    if (typeof swiper.slideTo === 'function') {
      swiper.slideTo(0, 0);
    }
  }

  ReviewFlicker.prototype.pauseAutoplayForModal = function () {
    if (!this.swiper || !this.swiper.autoplay || typeof this.swiper.autoplay.stop !== 'function') return;
    this._autoplayPausedForModal = true;
    this.swiper.autoplay.stop();
  };

  ReviewFlicker.prototype.resumeAutoplayAfterModal = function () {
    if (!this._autoplayPausedForModal) return;
    this._autoplayPausedForModal = false;

    var self = this;
    window.requestAnimationFrame(function () {
      if (!self.swiper || !self.swiper.autoplay || typeof self.swiper.autoplay.start !== 'function') return;

      var rect = self.root.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      var inView = rect.bottom > 0 && rect.top < viewportHeight;

      if (inView) {
        self.swiper.autoplay.start();
      }
    });
  };

  ReviewFlicker.prototype.bindViewportAutoplay = function () {
    var self = this;

    if (this._viewportObserver) {
      this._viewportObserver.disconnect();
      this._viewportObserver = null;
    }

    if (!this.swiper || !this.swiper.autoplay) return;

    this.swiper.autoplay.stop();

    if (!('IntersectionObserver' in window)) {
      this.swiper.autoplay.start();
      return;
    }

    this._viewportObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!self.swiper || !self.swiper.autoplay) return;

          if (entry.isIntersecting) {
            if (self._autoplayPausedForModal) return;
            self.swiper.autoplay.start();
            return;
          }

          self.swiper.autoplay.stop();
          resetSwiperToStart(self.swiper);
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.2
      }
    );

    this._viewportObserver.observe(this.root);
  };

  ReviewFlicker.prototype.initSwiper = function () {
    var self = this;
    var gapMobile = parseInt(this.sliderEl.getAttribute('data-gap-mobile'), 10) || 12;
    var gapDesktop = parseInt(this.sliderEl.getAttribute('data-gap'), 10) || 24;
    var viewMobile = parseFloat(this.sliderEl.getAttribute('data-view-mobile')) || 1.2;
    var viewDesktop = parseFloat(this.sliderEl.getAttribute('data-view')) || 4;
    var reviewCount = (this.reviews && this.reviews.length) || 0;
    var enableMobileLoop = reviewCount > 2;
    var enableDesktopLoop = reviewCount > 4;
    var autoplayConfig =
      reviewCount > 1
        ? {
            delay: 1000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
            reverseDirection: false
          }
        : false;

    waitForSwiper(function () {
      if (self._viewportObserver) {
        self._viewportObserver.disconnect();
        self._viewportObserver = null;
      }

      if (self.swiper) {
        if (self.swiper.autoplay && typeof self.swiper.autoplay.stop === 'function') {
          self.swiper.autoplay.stop();
        }
        self.swiper.destroy(true, true);
      }

      self.swiper = new window.Swiper(self.sliderEl, {
        speed: 350,
        loop: enableMobileLoop,
        rewind: !enableMobileLoop,
        centeredSlides: true,
        initialSlide: 0,
        slidesPerView: viewMobile,
        slidesPerGroup: 1,
        spaceBetween: gapMobile,
        watchOverflow: true,
        allowTouchMove: true,
        grabCursor: true,
        preventClicks: false,
        preventClicksPropagation: false,
        noSwiping: true,
        noSwipingClass: 'swiper-no-swiping',
        autoplay: autoplayConfig,
        navigation: {
          nextEl: self.nextBtn,
          prevEl: self.prevBtn
        },
        breakpoints: {
          768: {
            loop: enableDesktopLoop,
            rewind: !enableDesktopLoop,
            spaceBetween: gapDesktop,
            slidesPerView: viewDesktop,
            slidesPerGroup: 1
          }
        }
      });

      self.bindViewportAutoplay();

      if (self.cardLayout === 'vertical') {
        self.swiper.on('slideChange', function () {
          window.requestAnimationFrame(function () {
            self.syncVerticalSectionReadMore();
          });
        });
        window.requestAnimationFrame(function () {
          self.syncVerticalSectionReadMore();
        });
      }
    });
  };

  ReviewFlicker.prototype.showEmpty = function (message) {
    this.track.innerHTML = '<div class="wrf-empty">' + escapeHtml(message || 'No reviews yet.') + '</div>';
    if (this.summary) this.summary.hidden = true;
  };

  function boot() {
    var sections = document.querySelectorAll('[data-wom-review-flicker]');
    var i;
    for (i = 0; i < sections.length; i++) {
      new ReviewFlicker(sections[i]);
    }
  }

  function onReady() {
    boot();
  }

  if (!window.__wrfGlobalClickBound) {
    window.__wrfGlobalClickBound = true;
    document.addEventListener('click', handleFlickerDocumentClick, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', onReady);
  }
})();
